interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-xl shadow-sm'
          : 'bg-transparent'
      }`}
      style={{ height: '80px' }}
    >
      <div className="h-full px-8 lg:px-24 flex items-center justify-between">
        <div className="flex items-center">
          <img 
            src="https://public.readdy.ai/ai/img_res/a876a3c7-c004-4b93-9c73-dc121a4e3d29.png" 
            alt="SOMA d.o.o." 
            className="h-12 w-auto object-contain"
          />
        </div>

        <div className="flex items-center gap-10">
          <button
            onClick={() => scrollToSection('home')}
            className="text-base font-normal text-gray-800 hover:font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Home
          </button>
          <button
            onClick={() => scrollToSection('about')}
            className="text-base font-normal text-gray-800 hover:font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            About
          </button>
          <button
            onClick={() => scrollToSection('products')}
            className="text-base font-normal text-gray-800 hover:font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Products
          </button>
          <button
            onClick={() => scrollToSection('features')}
            className="text-base font-normal text-gray-800 hover:font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Features
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className="text-base font-normal text-gray-800 hover:font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Contact
          </button>
        </div>
      </div>
    </nav>
  );
}